const turkeyHotels = {
    116342: true,
    129528: true,
    107621: true,
    48505: true,
    47905: true,
    49477: true,
    47477: true,
    49604: true,
    47474: true,
    180202: true,
    48294: true,
    49554: true,
    48961: true,
    49149: true,
    127407: true,
    48516: true,
    49191: true,
    274476: true,
    47464: true,
    48152: true,
    48543: true,
    48794: true,
    48856: true,
    49019: true,
    49286: true,
    100596: true,
    107254: true,
    116341: true,
    284322: true,
    47414: true,
    47958: true,
    48796: true,
    119697: true,
    139482: true,
    143039: true,
    281805: true,
    47910: true,
    48164: true,
    48637: true,
    48698: true,
    48855: true,
    49611: true,
    97096: true,
    144037: true,
    277443: true,
    47480: true,
    47661: true,
    47672: true,
    47815: true,
    47921: true,
    48154: true,
    48432: true,
    48554: true,
    48624: true,
    48715: true,
    48824: true,
    48986: true,
    49026: true,
    49120: true,
    49153: true,
    49336: true,
    49422: true,
    49585: true,
    87309: true,
    87575: true,
    97783: true,
    98670: true,
    116316: true,
    116351: true,
    127329: true,
    133521: true,
    146470: true,
    47382: true,
    47478: true,
    47902: true,
    47990: true,
    47994: true,
    48011: true,
    48146: true,
    48273: true,
    48440: true,
    48479: true,
    48504: true,
    48511: true,
    48741: true,
    48762: true,
    48808: true,
    49017: true,
    49030: true,
    49068: true,
    49155: true,
    49248: true,
    49350: true,
    49369: true,
    49416: true,
    49417: true,
    49606: true,
    49630: true,
    97460: true,
    98045: true,
    98100: true,
    98427: true,
    104259: true,
    105249: true,
    105541: true,
    105648: true,
    106767: true,
    107407: true,
    111924: true,
    116426: true,
    116546: true,
    117198: true,
    129605: true,
    139076: true,
    140070: true,
    304924: true,
    304961: true,
    47378: true,
    47385: true,
    47481: true,
    47529: true,
    47531: true,
    47551: true,
    47595: true,
    47635: true,
    47653: true,
    47658: true,
    47662: true,
    47696: true,
    47843: true,
    47862: true,
    47870: true,
    47912: true,
    47962: true,
    47996: true,
    48007: true,
    48010: true,
    48019: true,
    48044: true,
    48045: true,
    48078: true,
    48099: true,
    48127: true,
    48224: true,
    48235: true,
    48257: true,
    48282: true,
    48329: true,
    48361: true,
    48401: true,
    48443: true,
    48455: true,
    48465: true,
    48481: true,
    48517: true,
    48566: true,
    48623: true,
    48642: true,
    48682: true,
    48719: true,
    48722: true,
    48729: true,
    48732: true,
    48748: true,
    48751: true,
    48761: true,
    48773: true,
    48799: true,
    48812: true,
    48871: true,
    48893: true,
    48899: true,
    48931: true,
    49075: true,
    49099: true,
    49115: true,
    49156: true,
    49166: true,
    49189: true,
    49223: true,
    49262: true,
    49263: true,
    49304: true,
    49319: true,
    49322: true,
    49329: true,
    49347: true,
    49374: true,
    49378: true,
    49405: true,
    49490: true,
    49513: true,
    49537: true,
    49563: true,
    49580: true,
    49583: true,
    49624: true,
    49643: true,
    49671: true,
    87463: true,
    87471: true,
    91240: true,
    97718: true,
    98040: true,
    98655: true,
    98779: true,
    100566: true,
    100831: true,
    101248: true,
    104261: true,
    104268: true,
    104379: true,
    104595: true,
    104972: true,
    105133: true,
    105175: true,
    105556: true,
    105636: true,
    105746: true,
    105811: true,
    105998: true,
    106758: true,
    106764: true,
    107622: true,
    115870: true,
    116346: true,
    116358: true,
    116382: true,
    116389: true,
    116550: true,
    117269: true,
    127306: true,
    127361: true,
    127416: true,
    127582: true,
    128244: true,
    128436: true,
    128538: true,
    129406: true,
    129791: true,
    133391: true,
    133555: true,
    135405: true,
    135432: true,
    138037: true,
    139003: true,
    139083: true,
    141015: true,
    141811: true,
    142073: true,
    143449: true,
    143876: true,
    276011: true,
    276283: true,
    277267: true,
    278648: true,
    279006: true,
    286050: true,
    288135: true,
    300587: true,
    306451: true,
    316312: true,
};

const UAEHotels = {
    11918: true,
    11972: true,
    11974: true,
    11978: true,
    11981: true,
    12007: true,
    12025: true,
    12031: true,
    12050: true,
    12089: true,
    12102: true,
    12151: true,
    12155: true,
    12162: true,
    12164: true,
    12226: true,
    12232: true,
    12236: true,
    12239: true,
    12242: true,
    12269: true,
    12276: true,
    12311: true,
    12321: true,
    12325: true,
    12368: true,
    12440: true,
    97103: true,
    100430: true,
    100737: true,
    100916: true,
    104802: true,
    106524: true,
    108244: true,
    111895: true,
    113687: true,
    115474: true,
    124801: true,
    129344: true,
    129349: true,
    130373: true,
    131411: true,
    133332: true,
    133681: true,
    134531: true,
    134533: true,
    135532: true,
    135554: true,
    136194: true,
    136839: true,
    136942: true,
    137272: true,
    137516: true,
    139744: true,
    139988: true,
    140422: true,
    140698: true,
    140702: true,
    140818: true,
    141436: true,
    142207: true,
    142339: true,
    144194: true,
    274722: true,
    274986: true,
    275692: true,
    275778: true,
    279830: true,
    280865: true,
    281655: true,
    282659: true,
    284229: true,
    284941: true,
    285952: true,
    286036: true,
    286568: true,
    291980: true,
    292644: true,
    294583: true,
    309740: true,
    317048: true,
    317598: true,

};
const thailandHotels = {
    15571: true,
    15625: true,
    15637: true,
    15676: true,
    15685: true,
    15698: true,
    15751: true,
    15771: true,
    15787: true,
    15789: true,
    15790: true,
    15838: true,
    15886: true,
    15887: true,
    15977: true,
    15986: true,
    15989: true,
    15996: true,
    16112: true,
    16121: true,
    16133: true,
    16155: true,
    16228: true,
    16301: true,
    16371: true,
    16380: true,
    16405: true,
    16438: true,
    16445: true,
    16459: true,
    16532: true,
    16540: true,
    16565: true,
    16575: true,
    16600: true,
    16615: true,
    16648: true,
    16656: true,
    16764: true,
    16774: true,
    16808: true,
    16835: true,
    16856: true,
    16909: true,
    16911: true,
    16931: true,
    16979: true,
    17011: true,
    17066: true,
    17068: true,
    65330: true,
    65331: true,
    65332: true,
    65341: true,
    65532: true,
    65639: true,
    65768: true,
    65781: true,
    65853: true,
    65859: true,
    65955: true,
    104844: true,
    105340: true,
    105847: true,
    105863: true,
    105877: true,
    105879: true,
    106446: true,
    106451: true,
    106660: true,
    106715: true,
    106849: true,
    108698: true,
    109077: true,
    109086: true,
    109704: true,
    110155: true,
    111225: true,
    111629: true,
    115738: true,
    120485: true,
    120490: true,
    120532: true,
    122854: true,
    129736: true,
    130450: true,
    130472: true,
    131452: true,
    132050: true,
    132293: true,
    132375: true,
    132944: true,
    132989: true,
    133369: true,
    133426: true,
    134979: true,
    136943: true,
    139411: true,
    139574: true,
    142316: true,
    142620: true,
    144044: true,
    196800: true,
    237587: true,
    263409: true,
    264559: true,
    275561: true,
    275701: true,
    286627: true,
    305134: true,
    306995: true,
    307809: true,
    321763: true,
    327029: true,
    328492: true,

};

export default {
    ...turkeyHotels,
    ...UAEHotels,
    ...thailandHotels,
};